import { render, staticRenderFns } from "./CaptureBeneficiaries.vue?vue&type=template&id=0f611859&"
import script from "./CaptureBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./CaptureBeneficiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports